import axiosInstance from '../utils/axiosInstance';

interface CreateRafExtractRequest {
  matterId: string;
  files: string[];
  intelligentMode?: boolean;
  isAdditive?: boolean;
  newFileMetadata?: { key: string; filename: string }[];
  /** Map of S3 object key -> password, for password-protected PDFs. */
  filePasswords?: Record<string, string>;
}

interface CreateRafExtractResponse {
  jobId: string;
  message: string;
  matterId: string;
}

export const createRafExtract = async (
  matterId: string,
  fileKeys: string[],
  intelligentMode?: boolean,
  options?: {
    isAdditive?: boolean;
    newFileMetadata?: { key: string; filename: string }[];
    /** S3-key -> password map for any password-protected PDFs among fileKeys. */
    filePasswords?: Record<string, string>;
  },
): Promise<string> => {
  const body: CreateRafExtractRequest = { matterId, files: fileKeys };
  if (intelligentMode) body.intelligentMode = true;
  if (options?.isAdditive) body.isAdditive = true;
  if (options?.newFileMetadata) body.newFileMetadata = options.newFileMetadata;
  if (options?.filePasswords && Object.keys(options.filePasswords).length > 0) {
    body.filePasswords = options.filePasswords;
  }
  const response = await axiosInstance.post<CreateRafExtractResponse>('/raf-extract/create', body);
  return response.data.jobId;
};
